import { ReducerActionRotaSP } from 'store/modules/types';

import { Types, CadastrarStatusRequest } from './types';

export function cadastrarStatusRequest(
	token: string,
	data: CadastrarStatusRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_STATUS,
		token,
		payload: data,
	};
}
export function cadastrarStatusSuccess(payload: object): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_STATUS_SUCCESS,
		payload,
	};
}
export function cadastrarStatusFailure(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_STATUS_FAILURE,
		payload: null,
	};
}
export function cadastrarStatusClear(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_STATUS_CLEAR,
		payload: null,
	};
}
